import { Link } from "react-router-dom";
import { slugify } from "../../utils/slugify.js";
import useLectureProgress from "../../utils/hooks/useLectureProgress.js";

const LectureProgressItem = ({ title, realTitle, to, onClick, className, allowToggle }) => {
  const slug = slugify(realTitle || title);
  const { completed, toggleComplete } = useLectureProgress(slug, allowToggle);

 // console.log("LectureProgressItem title prop:", title, typeof title);

  return (
    <li className={className} onClick={onClick} style={{ cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={completed}
        disabled={!allowToggle}
        onClick={(e) => e.stopPropagation()}
        onChange={allowToggle ? toggleComplete : undefined}
      />
      <span className="lecture-text">
        {(() => {
          const display = typeof title === "string"
              ? title
              : title?.title || "";

          return to ? (
            <Link to={to}>{display.toUpperCase()}</Link>
          ) : (
            display.toUpperCase()
          );
        })()}
      </span>
    </li>
  );
};

export default LectureProgressItem;